import * as React from "react";
import Svg, { Path } from "react-native-svg";

function IcSystemChevronLeft(props) {
  return (
    <Svg
      width={props.width}
      height={props.height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M15 6L9 12L15 18"
        stroke={props.accentColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

IcSystemChevronLeft.defaultProps = {
  accentColor: "#687176",
  fillColor: "#0194F3",
  width: 24,
  height: 24,
};
export default IcSystemChevronLeft;
